// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { useRequest } from "redux-query-react";
import { useSelector } from 'react-redux';
import * as QueryString from 'query-string';
import { isEqual } from "lodash";
import * as runtime from '../runtime';
import { objectToHash } from "common/object-helper";
import { FundFromJSON, } from '../models';
/**
 * Get fund by id
 * Get fund by id
 */
export function getFundByIdRaw(requestParameters, requestConfig = {}) {
    if (requestParameters.id === null || requestParameters.id === undefined) {
        throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getFundById.');
    }
    let queryParameters = null;
    let queryString = "";
    queryParameters = {};
    if (requestParameters.currency !== undefined) {
        queryParameters['currency'] = requestParameters.currency;
    }
    queryString = `?${QueryString.stringify(queryParameters)}`;
    if (requestParameters.asOfDate !== undefined) {
        queryParameters['asOfDate'] = requestParameters.asOfDate.toISOString().substr(0, 10);
    }
    queryString = `?${QueryString.stringify(queryParameters)}`;
    if (requestParameters.positionId !== undefined) {
        queryParameters['positionId'] = requestParameters.positionId;
    }
    queryString = `?${QueryString.stringify(queryParameters)}`;
    const headerParameters = {};
    const { meta = {} } = requestConfig;
    const config = {
        url: runtime.BASE_PATH + `/fund/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))) + queryString,
        meta,
        update: requestConfig.update || {
            Fund: (prevValue, transformedValue) => {
                return { ...prevValue, ...transformedValue };
            }
        },
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'GET',
            headers: headerParameters,
        },
        body: queryParameters,
        transform: requestConfig.transform ? requestConfig.transform : (body, text) => {
            const objResponse = FundFromJSON(body);
            let key = "";
            if (requestParameters.id) {
                key = `${key}${requestParameters.id}`;
            }
            if (requestParameters.currency) {
                key = `${key}${requestParameters.currency}`;
            }
            if (requestParameters.asOfDate) {
                key = `${key}${requestParameters.asOfDate}`;
            }
            if (requestParameters.positionId) {
                key = `${key}${requestParameters.positionId}`;
            }
            return { Fund: { [key]: objResponse } };
        }
    };
    config.queryKey = requestConfig.queryKey || `GetFundById-${objectToHash(requestParameters)}`;
    return config;
}
/**
* Get fund by id
* Get fund by id
*/
/**
 * Use this selector to get a reference to a single Fund matching the id
 * @param id Id of the Fund
 * @returns The Fund object
 */
export const useFundByIdSelector = (id, currency, asOfDate, positionId) => {
    let key = "";
    if (id) {
        key = `${key}${id}`;
    }
    if (currency) {
        key = `${key}${currency}`;
    }
    if (asOfDate) {
        key = `${key}${asOfDate}`;
    }
    if (positionId) {
        key = `${key}${positionId}`;
    }
    return useSelector((state) => state.entities.Fund[key], isEqual);
};
/**
 * Request hook for a single Fund. Beware, this should not be called without a valid id ***WIP***
 * @param id id of the Fund
 * @returns an array containing the data, query state, and a call for refresh
 * (note : refresh shouldn't be necessary, update to the state should be handle by mutators)
 */
export const useGetFundById = (requestParameters, customQueryConfig) => {
    const [querystate, forceRefresh] = useRequest(getFundByIdRaw(requestParameters, customQueryConfig));
    return [
        useFundByIdSelector(requestParameters.id, requestParameters.currency, requestParameters.asOfDate, requestParameters.positionId),
        querystate,
        forceRefresh
    ];
};
export function getFundById(requestParameters, requestConfig) {
    return getFundByIdRaw(requestParameters, requestConfig);
}
